
<template>
    <el-dialog title="企业" :visible.sync="dialogFormVisible2">
         <div class="avue-crud">
      <avue-crud :data="list" :option="tableoption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow" @search-change="searchChange">
            <template slot="search">
                <el-form-item label="企业名称">
                    <el-input placeholder="请输入企业名称" v-model="form.condition" clearable></el-input>
                </el-form-item>
                <el-form-item label="企业状态">
                    <el-select v-model="form.state" placeholder="请选择" clearable>
                        <el-option  v-for="item in workerState" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template  slot="menuLeft">
                <el-button type="primary" @click="change_pwd" size="mini" :disabled = "totalStatus">确 定</el-button>
            </template>
            <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
            </template>
        </avue-crud>
    </div>
    </el-dialog>

</template>
<script>
  import {companytable} from '@/const/asset/user'
  import {fetchList} from "@/api/admin/business"
  import {objKeySort} from '@/util/ajaxsign'
    import {dealElement} from '@/util/util'
  export default {
    name: 'table_user',
    data() {
      return {
        // 搜索
        form: {
            condition: '',
            state:''
        },
        radio:'',
        list: [],
        derail : true,
        coldderail : true,
        nocoldderail : true,
        listLoading: true,
        dictionarylist : {},
        workerState : [{value:0,label:"未认证"},{value:1,label:"待审核"},{value:2,label:"已认证"},{value:3,label:"拒绝审核"},{value:4,label:"已冻结"}],
        totalStatus : true,
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableoption : companytable,
        dialogFormVisible2 : false
      }
    },
    created() {

    },
    methods: {
      //设置用户id
      setuserid : function(){
        this.dialogFormVisible2 = true;
        this.getList();
        this.tableoption.height = 300;
      },
     showRow(row){
       console.log("选择企业：",row);
        this.radio = row.id;
        this.name = row.name;
        this.state = row.state;
        this.derail =false;
        this.nocoldderail = false;
        this.coldderail = false;
        this.totalStatus = false;
    },

    //确定
    change_pwd(){
        if(this.state == 4){
          this.$alert('您选择的企业已冻结，不能发布需求。', '温馨提示', {
            confirmButtonText: '确定'

          });
          return;
        }
        this.$emit('refresh',this.radio,this.name,this.state);
        this.dialogFormVisible2 = false;
    },

      getList() {
        this.listLoading = true
        this.form.pageNum=this.page.currentPage
        this.form.pageSize = this.page.pageSize
        fetchList(objKeySort(dealElement(this.form))).then(response => {
           this.list = response.data.data.rows
           this.page.total = response.data.data.total
           this.listLoading = false
        })
      },
      //搜索
      searchChange() {
        this.getList()
      },
      //分页
      sizeChange(val) {
        this.page.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.getList()
      },

    }
  }
</script>
